import { bindable, bindingMode } from 'aurelia-framework';

export class ToggleBadge {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) checked: Boolean;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) value: String;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) text: String;

    checkbox: any;
    isSelected: Boolean;
    toggle() {
        this.isSelected = this.checkbox.checked = !this.checkbox.checked;

        //this method doesn't work in IE11
        //this.checkbox.dispatchEvent(new Event("change"));

        //alternate solution that works in IE11 and evergreen browsers.
        var event = document.createEvent("HTMLEvents");
        event.initEvent("change", true, false);

        this.checkbox.dispatchEvent(event);
    }

}